import { render, staticRenderFns } from "./new-policy.vue?vue&type=template&id=21a5cc63&scoped=true&"
import script from "./new-policy.vue?vue&type=script&lang=js&"
export * from "./new-policy.vue?vue&type=script&lang=js&"
import style0 from "./new-policy.vue?vue&type=style&index=0&id=21a5cc63&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a5cc63",
  null
  
)

export default component.exports